import { compose } from 'recompose';
import Details from './Details';
import { query } from './API';
import withRequestTracker from '../../../../utils/composition/withRequestTracker';

const composedSubDAssortmentDetails = compose(withRequestTracker({ query }))(Details);

export default composedSubDAssortmentDetails;
